import React from 'react';
import { Form, InputNumber, Radio, Space } from 'antd';
import { useTranslation } from 'react-i18next';

interface Props { value: number; total: number; onChange: (value: number) => void;
  readOnly?: boolean; label: string }
const ThresholdField: React.FC<Props> = ({ value, total, onChange, readOnly, label }) => {
  const { t } = useTranslation();
  if (total <= 1) return null;
  return <Form layout="vertical"><Form.Item label={label}>
    <Radio.Group value={value === 0 ? 'all' : 'minimum'} disabled={readOnly}
      onChange={event => onChange(event.target.value === 'all' ? 0 : Math.max(1, total - 1))}>
      <Space direction="vertical"><Radio value="all">{t('graphicDesignLesson.admin.thresholdAll')}</Radio>
        <Radio value="minimum">{t('graphicDesignLesson.admin.thresholdMinimum')}{' '}
          <InputNumber min={1} max={total} value={value || Math.max(1, total - 1)}
            disabled={readOnly} onChange={next => onChange(next ?? 1)} />{' '}
          {t('graphicDesignLesson.admin.thresholdOf', { total })}</Radio></Space>
    </Radio.Group>
  </Form.Item></Form>;
};
export default ThresholdField;
